import jwt_decode from "jwt-decode";
import  secureLocalStorage  from  "react-secure-storage";


export const validateToken = (token) => {
  const now = Math.round(new Date().getTime() / 1000);
  const decodedToken = jwt_decode(token);
  const isValid = decodedToken && now < decodedToken.exp;

  return isValid;
};


export const toSeconds = (hour,minutes) =>{
    const hr = hour
    const min = minutes
    const total_time = hr*60*60 + min*60

    return total_time;
};

export const hmsToSecond = (hour,minutes)=>{
   return Number(hour)*60*60 + Number(minutes)*60

}

export const secondToHms = (seconds)=>{
    let d = Number(seconds);
    var h = parseInt((d / 3600));
    var m = parseInt((d % 3600 / 60));
    var s = parseInt((d % 3600 % 60));
    return [h,m,s]

}

export const teamTimerConverter = (hour,minute)=>{
  var total_time = hmsToSecond(hour,minute)
  var half_time = total_time / 2
  return secondToHms(half_time)

}

export const clearleftSecureLocalStorage=()=>{
  secureLocalStorage.removeItem("hour-left")
  secureLocalStorage.removeItem("min-left")
  secureLocalStorage.removeItem("sec-left")


}

export const clearAllSecureLocalStorage=()=>{
  secureLocalStorage.removeItem("hour-left")
  secureLocalStorage.removeItem("min-left")
  secureLocalStorage.removeItem("sec-left")
  secureLocalStorage.removeItem("hour-right")
  secureLocalStorage.removeItem("min-right")
  secureLocalStorage.removeItem("sec-right")
  secureLocalStorage.removeItem("topic")
  secureLocalStorage.removeItem("leftspeak")
  secureLocalStorage.removeItem("rightspeak")
  secureLocalStorage.removeItem("data-hours1")
  secureLocalStorage.removeItem("data-minutes1")
  secureLocalStorage.removeItem("data-seconds1")
  secureLocalStorage.removeItem("data-hours2")
  secureLocalStorage.removeItem("data-minutes2")
  secureLocalStorage.removeItem("data-seconds2")
  secureLocalStorage.removeItem("started")
  secureLocalStorage.removeItem("sec")
  secureLocalStorage.removeItem("min")
  secureLocalStorage.removeItem("hour")






}

